export default (function (){

    var defaults = {

        lang: "de",

        selectors: {
            forms: "form[data-parsley-validate]",
            field_container: ".formField",
            messages: ".formField-message",
        },

        classes: {
            is_valid: "is-valid",
            has_error: "is-invalid",
        },

        submit: {
            selector: "",
            disable: true,
        },

        disable_submit: true,

    };

    var init = function(form){

        var forms = $(defaults.selectors.forms);

        if (forms.length === 0){
            return;
        }

        addValidators();

        fixIEDateInput();

        $("form[data-parsley-validate]").each(function(){
            new Validator(this);
        });

    };

    var Validator = function(form){

        var self = this;

        this.settings = $.extend(true, {}, defaults);

        this.form = $(form);
        this.submit = $('button[type="submit"]', this.form);

        if (! $.isFunction($.fn.parsley)){
            return;
        }

        this.form.parsley({
            excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]",
            errorClass: this.settings.classes.has_error,
            successClass: this.settings.classes.is_valid,
            errorsWrapper: '<ul class="formField-message parsley-errors-list"></ul>',
            errorsContainer: function (field) { return getContainer(field) },
            lang: 'en',
        }).on("field:validated", function(formField){

            self.disableSubmit(! self.form.parsley().isValid());

        }).on("field:success", function(formField){

            var parent = self.getParent(formField.$element);

            parent.addClass(self.settings.classes.is_valid);
            parent.removeClass(self.settings.classes.has_error);

            self.toggleOtherMessages(parent, true);

        }).on("field:error", function(formField){

            var parent = self.getParent(formField.$element);

            parent.removeClass(self.settings.classes.is_valid);
            parent.addClass(self.settings.classes.has_error);

            self.toggleOtherMessages(parent, false);

        });

            // Set language

        if ( $("html").attr("lang") ){

            var locale = $("html").attr("lang") || defaults.lang;

            var matches = locale.match(/^[a-zA-Z]{2}/),
                lang = matches[0] || defaults.lang;

            try {
                window.Parsley.setLocale("en");
            } catch (e) {
                console.log("formValidator: The set language is not available.");
            }

        }

        this.disableSubmit(true);

    };

    Validator.prototype.toggleOtherMessages = function(parent, visible){

        parent.find(defaults.selectors.messages).not(".parsley-errors-list").toggle(visible);

    }

    function getContainer(field){

        var element = field.$element;

        if (! element.hasClass(defaults.selectors.field_container)){
            return element.closest(defaults.selectors.field_container);
        }

        return;

    }

    Validator.prototype.disableSubmit = function(disable){

        if (! this.settings.submit.disable){
            return;
        }

        this.submit.toggleClass('disabled', disable);

    }

    Validator.prototype.getParent = function(element){

        return element.closest(this.settings.selectors.field_container);

    }

    Validator.prototype.updateUI = function(refresh) {
    };

    Validator.prototype.validate = function(refresh) {

        this.form.parsley().validate();

        return this.form.parsley().isValid();

    };

    Validator.prototype.submit = function(callback){

        var callback = (typeof callback === "function") ? callback : function(){};

        if (! $.isFunction($.fn.parsley)){
            callback();
            return true;
        }

        var is_valid = this.validate();

        if (is_valid){
            callback();
        }

        return is_valid;

    };

    var addValidators = function(){

        window.Parsley.addValidator('maxFileSize', {

            validateString: function(_value, maxSize, parsleyInstance) {

                if (! window.FormData) {
                    return true;
                }

                var files = parsleyInstance.$element[0].files;

                return files.length != 1 || files[0].size <= maxSize * 1024;

            },

            requirementType: 'integer',

            messages: {
                en: 'This file should not be larger than %s Kb.',
                de: 'Die Datei darf nicht größer als %s KB sein.',
            }

        });

        window.Parsley.addValidator('fileTypes', {

            validateString: function(_value, types, parsleyInstance) {

                if (! window.FormData || ! types) {
                    return true;
                }

                var types = types.split(/, ?/);

                var files = parsleyInstance.$element[0].files;

                return files.length != 1 || types.indexOf(files[0].type) !== -1;

            },

            requirementType: 'string',

            messages: {
                en: 'This file is not the right type.',
                de: 'Die Datei ist vom falschen Typ.',
            }

        });

    };

    var fixIEDateInput = function(input){

        function getInternetExplorerVersion(){

            var rV = -1; // Return value assumes failure.

            if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {
                var uA = navigator.userAgent;
                var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

                if (rE.exec(uA) != null) {
                    rV = parseFloat(RegExp.$1);
                }
                else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                    rV = 11;
                }
            }

            return rV;

        }

        if (getInternetExplorerVersion() === -1){
            return;
        }

        $('input[type="date"]').each(function(){

            var input = $(this);

                // Please regard: Pattern does not check if date exists,
                //   so eg. `31.02.2000` will be valid

            var pattern = "([0-2][1-9]|3[0-1])\\.(0[1-9]|1[0-2])\\.(19|20)\\d{2}";

            input.attr("type", "text")
                 .attr("data-parsley-pattern", pattern)
                 .attr("data-parsley-validation-threshold", "10");

        });

    }

    return {
        init: init
    };

})();
